module.exports =
  base: '/alpha/'
  views:
    design: '/alpha/views/design'
    confirmed: '/alpha/views/order/confirmed'
    approval: '/alpha/views/order/approval'
    order:
      status: '/alpha/views/order/status'

    deco:
      detail: '/alpha/views/deco/detail'
      coordinator: '/alpha/views/deco/coordinator'
    test:
      design: '/alpha/views/test/user/design'
      decoTest: '/alpha/views/test/decoCoordinator'
      approval: '/alpha/views/test/user/approval/order'


  widget:
    base: '/alpha/widget/base.js'
    demo: '/alpha/widget/demo.html'
    test: '/alpha/widget/test'



  data:
    artwork:
      bulk: '/alpha/data/artwork/bulk/'
    design:
      bulk: '/alpha/data/design/bulk/'
      search: '/alpha/data/design/search/:searchQuery'
      save: '/alpha/data/design/save'
      populate: '/alpha/data/design/populate'
      artwork:
        upload: '/alpha/data/design/artwork'
    shippingForm:
      base: '/alpha/data/shippingForm/:shippingFormId'
      bulk: '/alpha/data/shippingForm/bulk'
    deco:
      order:
        list: '/alpha/v2/data/order/list'
    order:
      bulk: '/alpha/v2/data/order/bulk'
      detail: '/alpha/v2/data/order/detail/:orderId'
      search: '/alpha/v2/data/order/search/:searchQuery'
      artworkApprove: '/alpha/v2/data/order/detail/:orderId/artworkApprove'
      change: '/alpha/v2/data/order/detail/:orderId/change'
      csApprove: '/alpha/v2/data/order/detail/:orderId/csApprove'
      csRequest: '/alpha/v2/data/order/detail/:orderId/csRequest'
    retrieveFDM4: '/alpha/v2/data/retrieveFDM4'




// WEBPACK FOOTER //
// ./~/oo-routes/routes/alpha.coffee